exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.input-group .intl-tel-input {\r\n  width: 100%;\n}\n.intl-tel-input .flag-container {\r\n  border-top-left-radius: 5px;\r\n  border-bottom-left-radius: 5px;\r\n  padding: 2px;\n}\n.input-group .intl-tel-input input {\r\n  border: 1px solid rgba(0, 0, 0, 0.2);\r\n  transition: border 0.3s ease-in;\r\n  min-height: 40px;\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  border-radius: 5px;\r\n  padding: 4px 8px;\r\n  font-size: 16px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-025d20fc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./scripts/src/components/referral/referral-main.vue
// module id = 544
// module chunks = 0